export const API_KEYS_INDEX_TOUR = {
  id: "api_keys_index",
  steps: [
    {
      element: '[data-tour="api-keys-form"]',
      popover: {
        title: "Gerar uma API Key",
        description:
          "Use essas chaves para autenticar chamadas do seu sistema à API de integração do billing.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="api-keys-list"]',
      popover: {
        title: "Chaves geradas",
        description: "Acompanhe o último uso de cada chave e revogue as que não usa mais.",
        side: "top",
      },
    },
  ],
};
